module.exports = "https://www.gc-pro.gnp.com.mx/3ec95c31acfb723bd96210f43eb51815.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/boton/07.png
// module id = 1011
// module chunks = 0 1